import React from "react";

import { KintoneExportReport } from "@graffer-inc/cloud-gov-core";
import {
  Pagination,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
} from "@graffer-inc/console-design-kit";
import { unixSecToTimeString } from "../../../../../utils/date-utils";

type Props = {
  kintoneExportReports: Pick<
    KintoneExportReport,
    "id" | "createdAtUnixSecond" | "startedAtUnixSecond"
  >[];

  moveToReportDetail: (reportId: KintoneExportReport["id"]) => void;

  currentExportReportsPage: number;
  setCurrentExportReportsPage: (page: number) => void;
  lastExportReportsPage: number;
};

export const KintoneExportReportsList: React.FC<Props> = ({
  kintoneExportReports,
  moveToReportDetail,
  currentExportReportsPage,
  setCurrentExportReportsPage,
  lastExportReportsPage,
}) => {
  return (
    <section>
      <Table>
        <TableHeader>
          <TableRow>
            <Th>ID</Th>
            <Th>実行日時</Th>
          </TableRow>
        </TableHeader>
        <TableBody>
          {kintoneExportReports.map(({ id, startedAtUnixSecond }) => {
            return (
              <TableRow
                key={id}
                onClick={() => {
                  moveToReportDetail(id);
                }}
              >
                <Td>{id}</Td>
                <Td>{unixSecToTimeString(startedAtUnixSecond)}</Td>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Pagination
        currentPage={currentExportReportsPage}
        onPageClick={setCurrentExportReportsPage}
        lastPage={lastExportReportsPage}
      />
    </section>
  );
};
